import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { CountryService } from "../shared";

@Component({
  selector: "country-list",
  templateUrl: "./country-list.component.html",
  styleUrls: ["./country-list.component.scss"],
})
export class CountryListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: CountryService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Paises - " + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/countries/country-list/country-list.component.ts